import debounce from 'lodash.debounce';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { components } from "react-select";
import AsyncSelect from 'react-select/async';
import { getModels } from '../services';
import { formatOptionLabelWithImage } from './MultiSelectInline';
import { modelToOption, NoOptionsMessage } from "./Selectors";

const searchModels = (keyword, callback) => {
    getModels({ keyword })
        .then(data => data.results.map(x => { return { ...x, name: `${x.brand_name} ${x.name}` }; }).map(modelToOption))
        .then(options => {
            callback(options);
        });
};

const searchModelsDebounced = debounce(searchModels, 400);


const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <span className="oi oi-magnifying-glass"></span>
        </components.DropdownIndicator>
    );
};


const SearchBarStyles = {
    control: (base) => ({
        ...base,
        minHeight: 50,
    }),
    dropdownIndicator: (base) => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    clearIndicator: (base) => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    option: (styles, state) => ({
        ...styles,
        cursor: 'pointer',
    }),
};


const SearchBar = ({ onChange }) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState("");
    const onInputChange = value => {
        setInputValue(value);
    };

    return <AsyncSelect
        cacheOptions
        loadOptions={searchModelsDebounced}
        onInputChange={onInputChange}
        onChange={onChange}
        components={{ DropdownIndicator, NoOptionsMessage }}
        isClearable={true}
        placeholder={t("Search by brand, model, reference...")}
        styles={SearchBarStyles}
        menuIsOpen={Boolean(inputValue)}
        formatOptionLabel={formatOptionLabelWithImage}
    />;
};


export default SearchBar;